/* unplugin-vue-components disabled */import { render } from "./ChannelIcon.vue?vue&type=template&id=ce6ff2ce&scoped=true"
import script from "./ChannelIcon.vue?vue&type=script&lang=js"
export * from "./ChannelIcon.vue?vue&type=script&lang=js"

import "./ChannelIcon.vue?vue&type=style&index=0&id=ce6ff2ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce6ff2ce"]])

export default __exports__